import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { createKey } from "../../utils/KeysUtil";

export default function CardVideoComponent(props) {
  return (
    // <>
    <div key={props.keyValue ? props.keyValue : createKey()} className="card col mb-0" style={{ minHeight: "336px" }}>
      {/* <div className="m-0 mt-0 mb-3"> */}
      <iframe
        width="100%"
        height="198"
        src={props.src}
        title={props.title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        // style={{ position: "relative", paddingBottom: "56.25%" }}
        style={{ borderRadius: "6px 6px 0 0" }}
      ></iframe>
      <div className="card-body" style={{ minHeight: "112px" }}>
        <a
          href={props.href}
          target="_blank"
          rel="noreferrer"
          className="btn btn-link text-primary text-decoration-none fw-normal fs-6 text-start ps-0 pt-0 pe-0"
          style={{
            marginBottom: "24px",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitBoxOrient: "3",
            WebkitLineClamp: "3",
            lineClamp: "3",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {props.title}
        </a>
        <div
          className="d-flex justify-content-between align-middle"
          style={{ position: "absolute", bottom: "8px", left: "16px", width: "calc(100% - 32px)" }}
        >
          <div>
            <p className="badge rounded-pill bg-primary pt-1 mb-1 me-2 fw-light" style={{ fontSize: "x-small" }}>
              {props.category}
            </p>
          </div>
          <div>
            <p className="card-title mb-0 pt-1" style={{ fontSize: "smaller" }}>
              {props.dtPublicacao}
            </p>
          </div>
        </div>
      </div>
    </div>
    // </>
  );
}
